import { Map } from 'immutable'
import {
  SET_REDIRECTS,
  SET_BULK_REDIRECTS,
  SET_REDIRECTS_OFFSET_LIMIT,
  SET_REDIRECT_ERROR,
  CLEAR_REDIRECT_ERROR,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_REDIRECTS: {
      const {
        storeKey, data, total, processing,
      } = payload
      return state.update(
        storeKey,
        Map(),
        (branch) => branch.merge(Map({ data, total, processing })),
      )
    }
    case SET_BULK_REDIRECTS: {
      const { storeKey, data } = payload
      return state.update(storeKey, Map(), (branch) => branch.merge(Map({ data })))
    }
    case SET_REDIRECTS_OFFSET_LIMIT: {
      const {
        storeKey, offset, limit, processing,
      } = payload
      return state.update(
        storeKey,
        Map(),
        (branch) => branch.merge(Map({ offset, limit, processing })),
      )
    }
    case SET_REDIRECT_ERROR: {
      const { err } = payload
      const newState = state.set('error', err)
      // console.log(`NewState: ${JSON.stringify(newState)}`)
      return newState
    }
    case CLEAR_REDIRECT_ERROR: {
      return state.delete('error')
    }
    default:
      return state
  }
}
